const bricksBeautePin = (() => {
  const pageBricksBeaute = (document.getElementById("pageBricksBeaute") != null);
  if (pageBricksBeaute) {



    let sW = window.innerWidth;

    const secPin = document.getElementById('jsSecPin');
    const pinWrap = secPin.querySelector('.js-pin-wrap');
    const pinBox = pinWrap.querySelector('.js-pin-box');
    const pinTriggers = pinWrap.querySelectorAll('.js-pin-trigger');

    const tabArea = pinWrap.querySelector('.js-tab-area');
    const tabBox = tabArea.querySelectorAll('.js-tab-box');

    const datasArea = pinWrap.querySelector('.js-datas-area');


    if (sW > 750) {

      {
        let to = gsap.to(pinBox, {
          scrollTrigger: {
            invalidateOnRefresh: true,
            trigger: pinBox,
            endTrigger: pinWrap,
            start: 'center center',
            end: 'bottom bottom',
            pin: true,
            // markers: true
          }
        })


        let target = document.querySelector('body');
        let observer = new ResizeObserver((entries) => {
          entries.forEach((entry) => {
            to.scrollTrigger.refresh()
            // console.log('comParallax refresh');
          });
        });
        observer.observe(target);
      }


      {
        let tl = gsap.timeline({
          scrollTrigger: {
            invalidateOnRefresh: true,
            trigger: pinTriggers[0],
            start: "0% 10%",
            onEnter: () => pinBox.classList.add('act-2'),
            // onEnterBack: () => console.log("onEnterBack"),
            // onLeave: () => console.log("onLeave"),
            onLeaveBack: () => pinBox.classList.remove('act-2'),
            // markers: true,
          },
        })
        let tl1 = gsap.timeline({
          scrollTrigger: {
            invalidateOnRefresh: true,
            trigger: pinTriggers[1],
            start: "0% 10%",
            onEnter: () => pinBox.classList.add('act-3'),
            // onEnterBack: () => console.log("onEnterBack"),
            // onLeave: () => console.log("onLeave"),
            onLeaveBack: () => pinBox.classList.remove('act-3'),
            // markers: true,
          },
        })
        let tl2 = gsap.timeline({
          scrollTrigger: {
            invalidateOnRefresh: true,
            trigger: pinTriggers[2],
            start: "0% 10%",
            onEnter: () => pinBox.classList.add('act-4'),
            // onEnterBack: () => console.log("onEnterBack"),
            // onLeave: () => console.log("onLeave"),
            onLeaveBack: () => pinBox.classList.remove('act-4'),
            // markers: true,
          },
        })


        let target = document.querySelector('body');
        let observer = new ResizeObserver((entries) => {
          entries.forEach((entry) => {
            tl.scrollTrigger.refresh()
            tl1.scrollTrigger.refresh()
            tl2.scrollTrigger.refresh()
          });
        });
        observer.observe(target);
      }

    } else {

      tabArea.classList.add('act-1');
      pinBox.classList.add('act-1');
      datasArea.classList.add('act-1');

      tabBox.forEach((element, index) => {
        element.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();

          // for (let i = 0; i < tabBox.length; i++) {
          //   tabBox[i].classList.remove('act');
          // }

          tabArea.classList.remove('act-1');
          tabArea.classList.remove('act-2');
          tabArea.classList.remove('act-3');
          tabArea.classList.remove('act-4');
          pinBox.classList.remove('act-1');
          pinBox.classList.remove('act-2');
          pinBox.classList.remove('act-3');
          pinBox.classList.remove('act-4');
          datasArea.classList.remove('act-1');
          datasArea.classList.remove('act-2');
          datasArea.classList.remove('act-3');
          datasArea.classList.remove('act-4');

          if (index == 0) {
            tabArea.classList.add('act-1');
            pinBox.classList.add('act-1');
            datasArea.classList.add('act-1');
          }

          if (index == 1) {
            tabArea.classList.add('act-2');
            pinBox.classList.add('act-2');
            datasArea.classList.add('act-2');
          }

          if (index == 2) {
            tabArea.classList.add('act-3');
            pinBox.classList.add('act-3');
            datasArea.classList.add('act-3');
          }

          if (index == 3) {
            tabArea.classList.add('act-4');
            pinBox.classList.add('act-4');
            datasArea.classList.add('act-4');
          }

        });
      });

    }




  }
})()
export default bricksBeautePin;